import { Tag } from 'antd'

import type { OrganizationRole } from 'src/api/main'

import type { WorkspaceUser } from '../types'
import { resolveNamedMemberRole } from '../utils'

import { UsersRoleTag } from './UsersRoleTag'

type Props = {
  record: WorkspaceUser
}

/**
 * The member's role as one chip: their workspace role by name when they hold
 * one, and the tier otherwise. Shared by the members table and the member's
 * Workspace access card so both name the same thing.
 */
export const MemberRoleTag = ({ record }: Props) => {
  const namedRole = resolveNamedMemberRole(record.roles)

  if (namedRole) {
    return <Tag style={{ marginInlineEnd: 0 }}>{namedRole.name}</Tag>
  }

  return <UsersRoleTag role={record.role as OrganizationRole} />
}
